import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';

// 引入模块
// 模块文件名，应该跟业务模块名称保持一致。
import app from './app';
import labao from '@/module/labao/store';
import coupon from '@/module/coupon/store';
import keepAlive from './keep-alive';
import createPersistedState from 'vuex-persistedstate';

const debug = process.env.NODE_ENV !== 'production';

// 使用Vuex，状态管理插件
Vue.use(Vuex);

// 创建并对外公开这个Vuex实例
export default new Vuex.Store({
  modules: {
    app,
    ...labao,
    ...coupon,
    keepAlive
  },
  /* eslint-disable */
  plugins: debug
    ? [createLogger()]
    : [
        createPersistedState({
          storage: window.sessionStorage,
          reducer(val) {
            return {
              app: val.app,
              coupon: val.coupon
            };
          }
        })
      ]
});
